import { useMemo, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAnalyticsFavorites } from "../lib/analyticsFavorites";
import { analyticsDestination } from "../lib/analyticsSearch";
import { FavoriteEntryContext } from "./AnalyticsFavorites";
import "./QuickAccess.css";

export default function QuickAccessPanel({ renderAnalytics }) {
  const { favorites, enabled, error } = useAnalyticsFavorites();
  const [limit, setLimit] = useState(6);
  const navigate = useNavigate();
  const location = useLocation();
  const entries = useMemo(() => [
    ...favorites.filter(entry => entry.kind === "Metric"),
    ...favorites.filter(entry => entry.kind === "Analytics"),
    ...favorites.filter(entry => entry.kind !== "Metric" && entry.kind !== "Analytics"),
  ], [favorites]);
  const displayed = entries.slice(0, limit);
  const rows = [
    { key: "metrics", label: "Favorite KPI cards", entries: displayed.filter(entry => entry.kind === "Metric") },
    { key: "charts", label: "Favorite charts", entries: displayed.filter(entry => entry.kind === "Analytics") },
    { key: "reports", label: "Favorite reports and sections", entries: displayed.filter(entry => entry.kind !== "Metric" && entry.kind !== "Analytics") },
  ];
  return <section className="quick-access-panel" aria-label="Quick Access">
    <div className="quick-access-heading"><div><h2>Quick Access <span>({favorites.length})</span></h2>
      <p>Your starred KPIs, charts and reports in one place.</p></div>
      <small>Saved for your account in this browser.</small></div>
    {error && <div role="alert" className="quick-access-warning">{error}</div>}
    {!enabled ? <div className="quick-access-empty">Quick Access is unavailable for this account.</div> : !favorites.length ?
      <div className="quick-access-empty"><strong>No favorites yet</strong><p>Open any analytics tab and select the star beside a metric, chart or report. It will appear here with its live data.</p>
        <button type="button" onClick={() => navigate("/ceo-command-center")}>Browse Dashboard</button></div> : <>
      {rows.filter(row => row.entries.length).map(row =>
        <div key={row.key} className={`quick-access-grid quick-access-grid--${row.key}`} role="group" aria-label={row.label}>
          {row.entries.map(entry => <article className="quick-access-item" data-kind={entry.kind} key={entry.id}>
            <div className="quick-access-source"><span>{entry.tabLabel}</span>
              <button type="button" onClick={() => navigate(analyticsDestination(entry, location))}>Open in {entry.tabLabel} &rarr;</button></div>
            <FavoriteEntryContext.Provider value={entry}>{renderAnalytics(entry)}</FavoriteEntryContext.Provider>
          </article>)}
        </div>
      )}
      {entries.length > limit && <button type="button" className="quick-access-load-more" onClick={() => setLimit(value => value + 6)}>Show next {Math.min(6, entries.length - limit)} favorites ({entries.length - limit} remaining)</button>}
    </>}
  </section>;
}
